// constants/fileConstants.js

export const FETCH_FILES_REQUEST = 'FETCH_FILES_REQUEST';
export const FETCH_FILES_SUCCESS = 'FETCH_FILES_SUCCESS';
export const FETCH_FILES_FAIL = 'FETCH_FILES_FAIL';

export const FILE_DETAILS_REQUEST = 'FILE_DETAILS_REQUEST';
export const FILE_DETAILS_SUCCESS = 'FILE_DETAILS_SUCCESS';
export const FILE_DETAILS_FAIL = 'FILE_DETAILS_FAIL';

export const CREATE_FILE_REQUEST = 'CREATE_FILE_REQUEST';
export const CREATE_FILE_SUCCESS = 'CREATE_FILE_SUCCESS';
export const CREATE_FILE_RESET = 'CREATE_FILE_RESET';
export const CREATE_FILE_FAIL = 'CREATE_FILE_FAIL';

export const UPDATE_FILE_SUCCESS = 'UPDATE_FILE_SUCCESS';
export const UPDATE_FILE_FAIL = 'UPDATE_FILE_FAIL';

export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const DELETE_FILE_FAIL = 'DELETE_FILE_FAIL';
